export default {
  OK: "ตกลง,",
  ok: "ตกลง,",
  loginFailed: "เข้าสู่ระบบล้มเหลว กรุณาลองอีกครั้ง,",
  requestFailed: "คำขอล้มเหลว กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของคุณ,",
  invalidLogin: "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง,",
  thisFunctionExists: "ฟังก์ชันนี้มีอยู่แล้ว,",
  thisFunctionNotAllowDelete: "ไม่อนุญาตให้ลบฟังก์ชันนี้,",
  thisFunctionNotExists: "ฟังก์ชันนี้ไม่มีอยู่,",
  targetFunctionIdRequired: "ต้องระบุรหัสฟังก์ชันเป้าหมาย,",
  thisPageExists: "หน้านี้มีอยู่แล้ว,",
  thisPageNotAllowDelete: "ไม่อนุญาตให้ลบหน้านี้,",
  thisRoleExists: "บทบาทนี้มีอยู่แล้ว,",
  thisRoleNotAllowDelete: "ไม่อนุญาตให้ลบบทบาทนี้,",
  targetRoleIdRequired: "ต้องระบุรหัสบทบาทเป้าหมาย,",
  invalidParameter: "พารามิเตอร์ไม่ถูกต้อง",
  systemError: "ระบบไม่สามารถดำเนินการคำขอของคุณได้,",
  spErrorMessage: "ข้อผิดพลาดข้อความ SP (ขึ้นอยู่กับข้อผิดพลาดที่เกิดขึ้น),",
  actionbyRequired: "ต้องระบุผู้ใช้ปัจจุบัน,",
  sessionTokenRequired: "ต้องระบุโทเค็นเซสชัน,",
  functionIdRequired: "ต้องระบุรหัสฟังก์ชัน,",
  functionNameRequired: "ต้องระบุชื่อฟังก์ชัน,",
  newFunctionNameRequired: "ต้องระบุชื่อฟังก์ชัน,",
  pageIdRequired: "ต้องระบุรหัสหน้า,",
  newPageIdRequired: "ต้องระบุรหัสหน้า,",
  newPageNameRequired: "ต้องระบุชื่อหน้า,",
  targetPageIdRequired: "ต้องระบุรหัสหน้าที่ต้องการ,",
  userIdRequired: "ต้องระบุรหัสผู้ใช้,",
  passwordRequired: "รหัสผ่านจำเป็นต้องใช้,",
  userNameRequired: "ต้องระบุชื่อเต็ม,",
  passwordValidation: "รหัสผ่านต้องมีความยาว 6-20 ตัวอักษรและประกอบด้วยตัวเลขและตัวอักษร,",
  pageNumRequired: "หมายเลขหน้าเป็นสิ่งจำเป็น,",
  pageSizeRequired: "ขนาดหน้าคือสิ่งจำเป็น,",
  roleIdRequired: "รหัสบทบาทเป็นสิ่งจำเป็น,",
  oldPasswordRequired: "รหัสผ่านปัจจุบันเป็นสิ่งจำเป็น,",
  userStatusRequired: "สถานะผู้ใช้เป็นสิ่งจำเป็น,",
  newRoleIdRequired: "รหัสบทบาทเป็นสิ่งจำเป็น,",
  newRoleNameRequired: "ชื่อบทบาทเป็นสิ่งจำเป็น,",
  startDateIsGteEndDate: "วันที่เริ่มต้นมากกว่าวันที่สิ้นสุด,",
  thisRoleNotExists: "บทบาทนี้ไม่มีอยู่,",
  thisPageNotExists: "หน้านี้ไม่มีอยู่,",
  thisUserExists: "ผู้ใช้นี้มีอยู่แล้ว,",
  thisUserNotExists: "ผู้ใช้นี้ไม่มีอยู่",
  thisUserBlackListed: "บัญชีของคุณถูกระงับแล้ว,",
  thisUserInactive: "บัญชีของคุณถูกปิดใช้งานแล้ว,",
  thisUserBlocked: "บัญชีของคุณถูกบล็อกแล้ว,",
  thisUserNotActive: "บัญชีของคุณถูกปิดใช้งานแล้ว,",
  InvalidPageFunction: "ฟังก์ชันหน้าไม่ถูกต้อง,",
  invalidUser: "ผู้ใช้ไม่ถูกต้อง!,",
  invalidToken: "เซสชันไม่ถูกต้อง!,",
  NoUserAccessRight: "การเข้าถึงถูกปฏิเสธ!,",
  connection: "ข้อผิดพลาดในการเชื่อมต่อ,",
  profileIdRequired: "ต้องระบุ ID โปรไฟล์,",
  packageIdRequired: "ต้องระบุ ID แพ็คเกจ,",
  fullNameMinThreeChar: "ชื่อเต็มต้องมีอย่างน้อย 3 ตัวอักษร,",
  accountIdMinThreeChar: "ID บัญชีต้องมีอย่างน้อย 3 ตัวอักษร,",
  searchCriteriaRequired: "ต้องระบุเกณฑ์การค้นหา,",
  affiliateIdRequired: "รหัสพันธมิตรจำเป็นต้องมี,",
  minDepositRequired: "ต้องระบุเงินฝากขั้นต่ำ,",
  bonusRateRequired: "ต้องระบุอัตราโบนัส,",
  onlyAllowRejectDeposit: "อนุญาตให้ปฏิเสธตั๋วเงินฝากเท่านั้น,",
  senderBankIdRequired: "ต้องระบุรหัสธนาคารผู้ส่ง,",
  senderBankAccNoRequired: "ต้องระบุหมายเลขบัญชีธนาคารผู้ส่ง,",
  minFTDAmtNumOnly: "จำนวนเงิน FTD ขั้นต่ำยอมรับเฉพาะตัวเลข,",
  maxFTDAmtNumOnly: "จำนวนเงิน FTD สูงสุดยอมรับเฉพาะตัวเลข,",
  crmBasicCriteriaRequired: "ต้องระบุ ID สมาชิก / โทรศัพท์ติดต่อ / อีเมลติดต่อ / วันที่ลงทะเบียน / วันที่เข้าสู่ระบบล่าสุดบัญชีของคุณถูกระงับ",
  verifiedDateRangeAllowThreeMonths: "ช่วงวันที่สมัครสมาชิกอนุญาตให้เลือกได้สูงสุด 3 เดือนเท่านั้น",
  lastLoginDateRangeAllowThreeMonths: "ช่วงวันที่เข้าสู่ระบบครั้งล่าสุดอนุญาตให้เลือกได้สูงสุด 3 เดือนเท่านั้น",
  depositDateRangeAllowThreeMonths: "ช่วงวันที่ฝากเงินอนุญาตให้เลือกได้สูงสุด 3 เดือนเท่านั้น",
  ftdDateRangeAllowThreeMonths: "ช่วงวันที่ FTD อนุญาตให้เลือกได้สูงสุด 3 เดือนเท่านั้น",
  ltdDateRangeAllowThreeMonths: "ช่วงวันที่ LTD อนุญาตให้เลือกได้สูงสุด 3 เดือนเท่านั้น",
  lastLoginDateEarlierThanVerifiedDate: "วันที่เข้าสู่ระบบครั้งล่าสุดก่อนวันที่สมัครสมาชิก",
  depositDateEarlierThanVerifiedDate: "วันที่ฝากเงินก่อนวันที่สมัครสมาชิก",
  ftdDateEarlierThanVerifiedDate: "วันที่ FTD ก่อนวันที่สมัครสมาชิก",
  ltdDateEarlierThanVerifiedDate: "วันที่ LTD ก่อนวันที่สมัครสมาชิก",
  ftdFromRequired: "วันที่เริ่มต้น FTD เป็นสิ่งจำเป็น",
  ftdToRequired: "วันที่สิ้นสุด FTD เป็นสิ่งจำเป็น",
  ltdFromRequired: "วันที่เริ่มต้น LTD เป็นสิ่งจำเป็น",
  ltdToRequired: "วันที่สิ้นสุด LTD เป็นสิ่งจำเป็น",
  failedToLaunchPaymentGateway: "ไม่สามารถเปิดตัวเกตเวย์การชำระเงินได้,",
  enTitleRequired: "ต้องระบุ EN Title,",
  enBodyRequired: "ต้องระบุ EN Body,",
  enImageUrlRequired: "ต้องระบุ EN Image Url,",
  enImageUrlDesktopRequired: "ต้องระบุ EN Desktop Image Url,",
  enAltRequired: "ต้องระบุ EN Alt,",
  enHrefRequired: "ต้องระบุ EN Href,",
  resubmitTicketRequired: "ต้องระบุการส่งตั๋วใหม่,",
  withtholdBonusAndAmountGreaterThanZero: "ไม่สามารถระงับโบนัสและระงับจำนวนเงินได้มากกว่าศูนย์ในเวลาเดียวกัน,",
  maxWithdrawMultipleAndAmountGreaterThanZero: "จำนวนการถอนสูงสุดและจำนวนการถอนสูงสุดไม่สามารถมากกว่าศูนย์ได้ในเวลาเดียวกัน",
  serverBusy: "เซิร์ฟเวอร์กำลังยุ่งอยู่ตอนนี้ กรุณาลองอีกครั้ง",
  isRequired: "กรุณาใส่ {fname}.",
  isMinValue: "{fname} ต้องมีอย่างน้อย {fvalue}.",
  isMaxValue: "{fname} ต้องมีค่าน้อยกว่าหรือเท่ากับ {fvalue}.,",
  isMinLength: "{fname} ต้องมีอย่างน้อย {fvalue} ตัวอักษร.,",
  isMaxLength: "{fname} ต้องมีค่าน้อยกว่าหรือเท่ากับ {fvalue} ตัวอักษร.",
  isAlpha: "{fname} ยอมรับเฉพาะตัวอักษรเท่านั้น,",
  isAlphaNum: "{fname} ยอมรับเฉพาะตัวอักษรและตัวเลขเท่านั้น,",
  isNumeric: "{fname} ยอมรับเฉพาะตัวเลขเท่านั้น,",
  isEmail: "{fname} ยอมรับเฉพาะที่อยู่อีเมลที่ถูกต้องเท่านั้น,",
  isIpAddress: "{fname} ยอมรับเฉพาะที่อยู่ IPv4 ที่ถูกต้องเท่านั้น,",
  isSameAs: "{fname} ต้องเหมือนกับ {fname2},",
  isUrl: "{fname} ยอมรับเฉพาะ URL เท่านั้น",
  containAlphaNum: "{fname} ต้องมีอย่างน้อยหนึ่งตัวอักษรและหนึ่งตัวเลข,",
  alphaNumWithSpace: "{fname} ยอมรับเฉพาะอักขระตัวอักษรและตัวเลขเท่านั้น,",
  isDecimal: "{fname} ยอมรับเฉพาะตัวเลขเท่านั้น,",
  isInteger: "{fname} ยอมรับเฉพาะจำนวนเต็มเท่านั้น",
  selectOption: "กรุณาเลือก {fname},",
  notSameAs: "{fname} และ {fname2} ไม่สามารถเหมือนกันได้,",
  dateRangeAllowOneMonth: "ช่วงวันที่อนุญาตให้เลือกได้สูงสุด 1 เดือน,",
  dateRangeAllowOneYear: "ช่วงวันที่อนุญาตให้เลือกได้สูงสุด 1 ปี,",
  greaterThanZero: "{fname} ต้องมากกว่าศูนย์,",
  atLeastOneAuthority: "ต้องเลือกอย่างน้อยหนึ่งหน่วยงาน,",
  BLOCK: "บัญชีของคุณถูกบล็อก,",
  SUSPEND: "บัญชีของคุณถูกระงับ,",
  CLOSE: "บัญชีของคุณถูกปิด,",
  RESETL: "บัญชีของคุณถูกรีเซ็ต,",
  atLeastOneProvider: "ต้องเลือกอย่างน้อยหนึ่งผู้ให้บริการ",
  failedToGetResultUrl: "ไม่สามารถรับผลลัพธ์ URL ได้,",
  fileSizeValidation: "ขนาดใหญ่เกินไป ขนาดสูงสุดที่อนุญาตคือ 1MB,",
  atLeastOnePaymentOption: "ต้องเลือกตัวเลือกการชำระเงินอย่างน้อยหนึ่งตัว,",
  atLeastOnePaymentGateway: "ต้องเลือกเกตเวย์การชำระเงินอย่างน้อยหนึ่งตัว,",
  dateRangeAllow31Days: "ช่วงวันที่อนุญาตให้เลือกได้สูงสุด 31 วัน,",
  dateRangeAllow31Months: "ช่วงวันที่อนุญาตให้เลือกได้สูงสุด 31 เดือน,",
  dateRangeAllow31Years: "ช่วงวันที่อนุญาตให้เลือกได้สูงสุด 31 ปี,",
  invalidCategory: "หมวดหมู่ไม่ถูกต้อง",
  noChanges: "ไม่มีการเปลี่ยนแปลง",
  permissionDenied: "การอนุญาตถูกปฏิเสธ",
  referralCodeRequired: "ต้องการรหัสแนะนำ",
  providerDescRequired: "ต้องการคำอธิบายผู้ให้บริการ",
  marqueeContentRequired: "เนื้อหามาร์คีจำเป็นต้องมี,",
  bonusNameRequired: "ชื่อโบนัสจำเป็นต้องมี,",
  baseAmountRequired: "จำนวนพื้นฐานจำเป็นต้องมี,",
  reviewIdRequired: "หมายเลขรีวิวจำเป็นต้องมี,",
  surveyIdRequired: "หมายเลขสำรวจจำเป็นต้องมี,",
  questionRequired: "คำถามจำเป็นต้องมี,",
  iframeIdRequired: "หมายเลขไอเฟรมจำเป็นต้องมี,",
  bonusAmountRequired: "จำนวนโบนัสจำเป็นต้องมี,",
  inboxIdRequired: "หมายเลขกล่องจดหมายจำเป็นต้องมี,",
  exchangedAmountRequired: "จำนวนที่แลกเปลี่ยนจำเป็นต้องมี,",
  baseRateRequired: "อัตราพื้นฐานจำเป็นต้องมี,",
  exchangeRateRequired: "อัตราแลกเปลี่ยนจำเป็นต้องมี,",
  baseCurrencyRequired: "สกุลเงินพื้นฐานจำเป็นต้องมี,",
  exchangeCurrencyRequired: "สกุลเงินที่แลกเปลี่ยนจำเป็นต้องมี,",
  depositTypeRequired: "ประเภทการฝากจำเป็นต้องมี,",
  nbRedepositRequired: "จำนวนการฝากซ้ำจำเป็นต้องมี,",
  bankOwnerRequired: "เจ้าของธนาคารจำเป็นต้องมี,",
  autoSenderRequired: "ผู้ส่งอัตโนมัติจำเป็นต้องมี,",
  isRecommendRequired: "การแนะนำจำเป็นต้องมี,",
  recipientBankIdRequired: "หมายเลขธนาคารผู้รับจำเป็นต้องมี,",
  recipientBankAccNoRequired: "หมายเลขบัญชีธนาคารผู้รับจำเป็นต้องมี,",
  accountBalanceRequired: "ยอดบัญชีจำเป็นต้องมี,",
  incomingAmountThresholdRequired: "เกณฑ์จำนวนเงินเข้าจำเป็นต้องมี,",
  incomingFrequencyThresholdRequired: "เกณฑ์ความถี่เข้าจำเป็นต้องมี,",
  outgoingAmountThresholdRequired: "เกณฑ์จำนวนเงินออกจำเป็นต้องมี,",
  outgoingFrequencyThresholdRequired: "เกณฑ์ความถี่ออกจำเป็นต้องมี,",
  bankAccTypeRequired: "ประเภทบัญชีธนาคารจำเป็นต้องมี,",
  packageRequired: "แพ็คเกจจำเป็นต้องมี,",
  rtpRequired: "RTP จำเป็นต้องมี,",
  domainIdRequired: "หมายเลขโดเมนจำเป็นต้องมี,",
  buyOnBehalfRequired: "ซื้อแทนจำเป็นต้องมี,",
  serviceProviderRequired: "ผู้ให้บริการจำเป็นต้องมี,",
  serverAccountRequired: "บัญชีเซิร์ฟเวอร์จำเป็นต้องมี,",
  nameServerRequired: "เซิร์ฟเวอร์ชื่อจำเป็นต้องมี",
  socialLinkRequired: "ลิงก์โซเชียลจำเป็นต้องใช้,",
  newSocialPlatformRequired: "แพลตฟอร์มโซเชียลใหม่จำเป็นต้องใช้,",
  attachmentPathRequired: "เส้นทางแนบไฟล์จำเป็นต้องใช้,",
  depositMethodRequired: "วิธีการฝากเงินจำเป็นต้องใช้,",
  depositDateRequired: "วันที่ฝากเงินจำเป็นต้องใช้,",
  refNoRequired: "หมายเลขอ้างอิงจำเป็นต้องใช้,",
  withdrawalAmountRequired: "จำนวนเงินที่ถอนจำเป็นต้องใช้,",
  targetBankAccNoRequired: "หมายเลขบัญชีธนาคารเป้าหมายจำเป็นต้องใช้,",
  targetBankIdRequired: "รหัสธนาคารเป้าหมายจำเป็นต้องใช้,",
  jsonRatingRequired: "การจัดอันดับ JSON จำเป็นต้องใช้,",
  startTimeRequired: "เวลาเริ่มต้นจำเป็นต้องใช้,",
  accountIdRequired: "รหัสบัญชีจำเป็นต้องใช้,",
  parentIdRequired: "รหัสผู้ปกครองจำเป็นต้องใช้,",
  amountRequired: "จำนวนเงินจำเป็นต้องใช้,",
  clientIpRequired: "IP ของลูกค้าจำเป็นต้องใช้,",
  auditByRequired: "การตรวจสอบโดยจำเป็นต้องใช้,",
  systemTypeRequired: "ประเภทระบบจำเป็นต้องใช้,",
  currencyRequired: "สกุลเงินจำเป็นต้องใช้,",
  ipAddressRequired: "ที่อยู่ IP จำเป็นต้องใช้,",
  affiliateCodeRequired: "รหัสพันธมิตรจำเป็นต้องใช้,",
  contactPhoneRequired: "หมายเลขโทรศัพท์ติดต่อจำเป็นต้องใช้,",
  requestTypeRequired: "ประเภทคำขอจำเป็นต้องใช้,",
  securityDisabledRequired: "การปิดการรักษาความปลอดภัยจำเป็นต้องใช้,",
  gameCodeRequired: "รหัสเกมจำเป็นต้องใช้,",
  seqRequired: "ลำดับจำเป็นต้องใช้,",
  minLimitRequired: "ขีดจำกัดขั้นต่ำจำเป็นต้องใช้,",
  maxLimitRequired: "ขีดจำกัดสูงสุดจำเป็นต้องใช้",
  commSportsRequired: "ต้องระบุค่าคอมมิชชั่นสำหรับกีฬา,",
  commSlotsRequired: "ต้องระบุค่าคอมมิชชั่นสำหรับสล็อต,",
  commLivecasinoRequired: "ต้องระบุค่าคอมมิชชั่นสำหรับคาสิโนสด,",
  commCockfightRequired: "ต้องระบุค่าคอมมิชชั่นสำหรับการชนไก่,",
  commOthersRequired: "ต้องระบุค่าคอมมิชชั่นสำหรับอื่นๆ,",
  settingValueRequired: "ต้องระบุค่าการตั้งค่า,",
  vipIdRequired: "ต้องระบุรหัส VIP,",
  carryOverRequired: "ต้องระบุการพกพา,",
  campaignIdRequired: "ต้องระบุรหัสแคมเปญ,",
  titleRequired: "ต้องระบุหัวข้อ,",
  bodyRequired: "ต้องระบุเนื้อหา,",
  itemOrderRequired: "ต้องระบุลำดับรายการ,",
  imageUrlRequired: "ต้องระบุ URL รูปภาพ,",
  bannerIdRequired: "ต้องระบุรหัสแบนเนอร์,",
  directionRequired: "ต้องระบุทิศทาง,",
  defaultOrderRequired: "ต้องระบุลำดับเริ่มต้น,",
  altRequired: "ต้องระบุข้อความแทน,",
  hrefRequired: "ต้องระบุ Href,",
  targetWindowRequired: "ต้องระบุหน้าต่างเป้าหมาย,",
  loginRequiredRequired: "ต้องระบุการเข้าสู่ระบบ,",
  activeFromRequired: "ต้องระบุวันที่เริ่มต้น,",
  activeToRequired: "ต้องระบุวันที่สิ้นสุด,",
  bannerTypeRequired: "ต้องระบุประเภทแบนเนอร์,",
  pageNameRequired: "ต้องระบุชื่อหน้า,",
  remarkRequired: "ต้องระบุหมายเหตุ,",
  settingKeyRequired: "ต้องระบุคีย์การตั้งค่า,",
  memberListRequired: "ต้องระบุรายชื่อสมาชิก,",
  memberIdRequired: "ต้องระบุรหัสสมาชิก,",
  workingMonthRequired: "ต้องระบุเดือนทำงาน,",
  workingDateRequired: "ต้องระบุวันที่ทำงาน,",
  tacRequired: "ต้องระบุข้อกำหนดและเงื่อนไข,",
  paymentModeRequired: "ต้องระบุโหมดการชำระเงิน,",
  newPasswordRequired: "ต้องระบุรหัสผ่านใหม่",
  loginIdRequired: "ต้องระบุรหัสเข้าสู่ระบบ,",
  securityTagRequired: "ต้องระบุแท็กความปลอดภัย,",
  securityCodeRequired: "ต้องระบุรหัสความปลอดภัย,",
  providerCodeRequired: "ต้องระบุรหัสผู้ให้บริการ,",
  startDateRequired: "ต้องระบุวันที่เริ่มต้น,",
  endDateRequired: "ต้องระบุวันที่สิ้นสุด,",
  searchIdRequired: "ต้องระบุรหัสค้นหา,",
  authTokenRequired: "ต้องระบุโทเค็นการตรวจสอบสิทธิ์,",
  newStatusRequired: "ต้องระบุสถานะใหม่,",
  actionRequired: "ต้องระบุการดำเนินการ,",
  promotionIdRequired: "ต้องระบุรหัสโปรโมชั่น,",
  promotionNameRequired: "ต้องระบุชื่อโปรโมชั่น,",
  rolloverRequired: "ต้องระบุการหมุนเวียน,",
  criteriaRequired: "ต้องระบุเกณฑ์,",
  ticketIdRequired: "ต้องระบุรหัสตั๋ว,",
  resultIdRequired: "ต้องระบุรหัสผลลัพธ์,",
  bankIdRequired: "ต้องระบุรหัสธนาคาร,",
  bankAccNoRequired: "ต้องระบุหมายเลขบัญชีธนาคาร,",
  bankAccHolderRequired: "ต้องระบุชื่อเจ้าของบัญชีธนาคาร,",
  newBankIdRequired: "ต้องระบุรหัสธนาคารใหม่,",
  newBankAccNoRequired: "ต้องระบุหมายเลขบัญชีธนาคารใหม่,",
  newBankAccHolderRequired: "ต้องระบุชื่อเจ้าของบัญชีธนาคารใหม่,",
  fullNameRequired: "ต้องระบุชื่อเต็ม,",
  depositAmountRequired: "ต้องระบุจำนวนเงินฝาก,",
  gatewayAccRequired: "ต้องระบุบัญชีเกตเวย์,",
  labelNameRequired: "ต้องระบุชื่อป้าย,",
  labelIdRequired: "ต้องระบุรหัสป้าย,",
  bankTypeRequired: "ต้องระบุประเภทธนาคาร,",
  amountLimitRequired: "ต้องระบุขีดจำกัดจำนวนเงิน,",
  currencyRateRequired: "ต้องระบุอัตราแลกเปลี่ยน,",
  urlRequired: "ต้องระบุ URL,",
  cashRequired: "ต้องระบุเงินสด",
  csRequired: "ต้องการการสนับสนุนลูกค้า,",
  vipNameRequired: "ต้องการชื่อ VIP,",
  campaignNameRequired: "ต้องการชื่อแคมเปญ,",
  transferIdRequired: "ต้องการ ID การโอน,",
  betTimeRequired: "ต้องการเวลาวางเดิมพัน,",
  turnoverRequired: "ต้องการยอดเทิร์นโอเวอร์,",
  payoutRequired: "ต้องการการจ่ายเงิน,",
  winloseRequired: "ต้องการผลชนะ/แพ้,",
  rawMessageRequired: "ต้องการข้อความดิบ,",
  authStatusRequired: "ต้องการสถานะการตรวจสอบ,",
  dateRequired: "ต้องการวันที่,",
  betIdRequired: "ต้องการ ID การเดิมพัน,",
  betStatusRequired: "ต้องการสถานะการวางเดิมพัน,",
  betAmountRequired: "ต้องการจำนวนเงินเดิมพัน,",
  isParlayRequired: "ต้องการการแทงพาร์เลย์,",
  isAddonRequired: "ต้องการการเพิ่ม,",
  withholdBonusRequired: "ต้องการโบนัสที่ถูกหัก,",
  withholdAmountRequired: "ต้องการจำนวนเงินที่ถูกหัก,",
  maxWithdrawAmountRequired: "ต้องการจำนวนเงินถอนสูงสุด,",
  betTypeRequired: "ต้องการประเภทการเดิมพัน,",
  maxWithdrawMultipleRequired: "ต้องการการถอนสูงสุดหลายเท่า,",
  socialPlatformRequired: "ต้องการแพลตฟอร์มโซเชียล,",
  vipProviderRebateRequired: "ต้องการการคืนเงินจากผู้ให้บริการ VIP,",
  selfRebateRateRequired: "ต้องการอัตราการคืนเงินของตนเอง,",
  downlineRebateRateRequired: "ต้องการอัตราการคืนเงินของสายงาน,",
  tierIdRequired: "ต้องการ ID ระดับ,",
  rebateRateRequired: "ต้องการอัตราการคืนเงิน,",
  paymentGatewayRequired: "ต้องการเกตเวย์การชำระเงิน,",
  rescueIdRequired: "ต้องการ ID การกู้คืน,",
  rescueNameRequired: "ต้องการชื่อการกู้คืน,",
  rescueCycleRequired: "ต้องการรอบการกู้คืน,",
  minLoseRequired: "ต้องการการแพ้ขั้นต่ำ,",
  rescueRateRequired: "ต้องการอัตราการกู้คืน,",
  maxPayoutRequired: "ต้องการการจ่ายเงินสูงสุด,",
  payoutMethodRequired: "ต้องการวิธีการจ่ายเงิน,",
  targetGroupRequired: "ต้องการกลุ่มเป้าหมาย",
  maintainDepositRequired: "ต้องมีการรักษาเงินฝาก,",
  maintainTurnoverRequired: "ต้องมีการรักษาเงินหมุนเวียน,",
  depositOrTurnoverRequired: "ต้องมีเงินฝากหรือเงินหมุนเวียน,",
  maintainDepositOrMaintainTurnoverRequired: "ต้องมีการรักษาเงินฝากหรือการรักษาเงินหมุนเวียน,",
  vipListRequired: "ต้องมีรายชื่อ VIP,",
  gameNameRequired: "ต้องมีชื่อเกม,",
  claimTypeRequired: "ต้องมีประเภทการเรียกร้อง,",
  operatorIdRequired: "ต้องมี ID ผู้ดำเนินการ,",
  maxBonusRequired: "ต้องมีโบนัสสูงสุด,",
  endTimeRequired: "ต้องมีเวลาสิ้นสุด,",
  mondayRequired: "ต้องมีวันจันทร์,",
  tuesdayRequired: "ต้องมีวันอังคาร,",
  wednesdayRequired: "ต้องมีวันพุธ,",
  thursdayRequired: "ต้องมีวันพฤหัสบดี,",
  fridayRequired: "ต้องมีวันศุกร์,",
  saturdayRequired: "ต้องมีวันเสาร์,",
  sundayRequired: "ต้องมีวันอาทิตย์,",
  promotionTypeRequired: "ต้องมีประเภทโปรโมชั่น,",
  claimLimitRequired: "ต้องมีขีดจำกัดการเรียกร้อง,",
  bonusRate1Required: "ต้องมีอัตราโบนัส 1,",
  bonusRate1To2Required: "ต้องมีอัตราโบนัส 1 ถึง 2,",
  bonusRate1To3Required: "ต้องมีอัตราโบนัส 1 ถึง 3,",
  bonusRate1To4Required: "ต้องมีอัตราโบนัส 1 ถึง 4,",
  bonusRate1To5Required: "ต้องมีอัตราโบนัส 1 ถึง 5,",
  bonusRate1To6Required: "ต้องมีอัตราโบนัส 1 ถึง 6,",
  bonusRate1To7Required: "ต้องมีอัตราโบนัส 1 ถึง 7,",
  externalIdRequired: "ต้องมี ID ภายนอก,",
  opsiteRequired: "ต้องมี Opsite,",
  opsiteContentRequired: "ต้องมีเนื้อหา Opsite,",
  opsiteLanguageRequired: "ต้องมีภาษา Opsite,",
  opsitePaymentRequired: "ต้องมีการชำระเงิน Opsite,",
  opsiteProviderRequired: "ต้องมีผู้ให้บริการ Opsite,",
  opsiteProviderGamesRequired: "ต้องมีเกมผู้ให้บริการ Opsite,",
  accountTypeRequired: "ต้องมีประเภทบัญชี,",
  domainNameRequired: "ต้องมีชื่อโดเมน,",
  settledTimeRequired: "ต้องมีเวลาที่ตั้งถิ่นฐาน",
  validTurnoverRequired: "ต้องมีการหมุนเวียนที่ถูกต้อง,",
  resultTimeRequired: "ต้องระบุเวลาผลลัพธ์,",
  resultStatusRequired: "ต้องระบุสถานะผลลัพธ์,",
  secondIdRequired: "ต้องมี ID ที่สอง,",
  domainListRequired: "ต้องมีรายการโดเมน,",
  domainTypeRequired: "ต้องระบุประเภทโดเมน,",
  moduleRequired: "ต้องมีโมดูล,",
  gameIdRequired: "ต้องมี ID เกม,",
  gameDetailRequired: "ต้องมีรายละเอียดเกม,",
  bonusRate1To8Required: "ต้องมีอัตราโบนัส 1 ถึง 8,",
  bonusRate1To9Required: "ต้องมีอัตราโบนัส 1 ถึง 9,",
  bonusRate1To10Required: "ต้องมีอัตราโบนัส 1 ถึง 10,",
  invalidOrder: "คำสั่งไม่ถูกต้อง",
  bannerNotExists: "แบนเนอร์ไม่มีอยู่จริง,",
  invalidBannerType: "ประเภทแบนเนอร์ไม่ถูกต้อง,",
  pageNameExists: "ชื่อเพจมีอยู่แล้ว,",
  pageNotExists: "เพจไม่มีอยู่จริง,",
  tacIsValid: "OTP ถูกต้อง,",
  invalidTac: "OTP ไม่ถูกต้อง,",
  tacExpired: "OTP หมดอายุ,",
  tacNotValidate: "OTP ไม่ได้รับการตรวจสอบ,",
  paymentModeNotExists: "โหมดการชำระเงินไม่มีอยู่จริง,",
  paymentOptionProviderNotExists: "ผู้ให้บริการตัวเลือกการชำระเงินไม่มีอยู่จริง,",
  ipAddressExists: "ที่อยู่ IP มีอยู่แล้ว,",
  ticketProcessed: "ตั๋วได้รับการประมวลผล,",
  bankAccountNotExists: "บัญชีธนาคารไม่มีอยู่จริง,",
  bankAccountInactive: "บัญชีธนาคารไม่ทำงาน,",
  bankMemberNotExists: "สมาชิกธนาคารไม่มีอยู่จริง,",
  bankMemberInactive: "สมาชิกธนาคารไม่ทำงาน,",
  affiliateExists: "พันธมิตรมีอยู่แล้ว,",
  contactPhoneExists: "หมายเลขโทรศัพท์ติดต่อมีอยู่แล้ว,",
  affiliateFull: "พันธมิตรเต็ม,",
  uplineInactive: "สายงานไม่ทำงาน,",
  applicationProcessed: "ใบสมัครได้รับการประมวลผล,",
  tacValidated: "ข้อกำหนดและเงื่อนไขได้รับการตรวจสอบ,",
  applicationPending: "ใบสมัครอยู่ระหว่างรอการดำเนินการ",
  favouriteGameExists: "เกมโปรดมีอยู่แล้ว,",
  invalidLimit: "ขีดจำกัดไม่ถูกต้อง,",
  settingNotSet: "การตั้งค่าไม่ได้ตั้งค่า,",
  domainNameNotExists: "ชื่อโดเมนไม่มีอยู่จริง,",
  domainNameFull: "ชื่อโดเมนเต็ม,",
  domainNameNotAvailable: "ชื่อโดเมนไม่พร้อมใช้งาน,",
  domainNameExists: "ชื่อโดเมนมีอยู่จริง,",
  subAccountNotExists: "บัญชีย่อยไม่มีอยู่จริง,",
  settingNotExists: "การตั้งค่าไม่มีอยู่จริง,",
  invalidContactEmail: "อีเมลติดต่อไม่ถูกต้อง,",
  accountInactive: "บัญชีไม่ใช้งาน,",
  campaignNotExists: "แคมเปญไม่มีอยู่จริง,",
  paymentProviderNotExists: "ผู้ให้บริการชำระเงินไม่มีอยู่จริง,",
  profileInactive: "โปรไฟล์ไม่ใช้งาน,",
  minWithdrawalNotMet: "การถอนขั้นต่ำไม่ถึง,",
  invalidBankId: "รหัสธนาคารไม่ถูกต้อง,",
  bankAccountExists: "บัญชีธนาคารมีอยู่จริง,",
  bankAccountFull: "บัญชีธนาคารเต็ม,",
  bankAccHolderNotSame: "เจ้าของบัญชีธนาคารไม่เหมือนกัน,",
  exceedMaxWithdrawal: "เกินการถอนสูงสุด,",
  exceedWithdrawalFrequency: "เกินความถี่ในการถอน,",
  invalidPackage: "แพ็คเกจไม่ถูกต้อง,",
  promotionNotAvailable: "โปรโมชั่นไม่พร้อมใช้งาน,",
  ongoingPromotion: "โปรโมชั่นกำลังดำเนินการ,",
  pendingResultInGame: "ผลลัพธ์ในเกมรอดำเนินการ,",
  labelNameExists: "ชื่อป้ายมีอยู่จริง,",
  labelNotExists: "ป้ายไม่มีอยู่จริง,",
  invalidFtdMin: "การฝากครั้งแรกขั้นต่ำไม่ถูกต้อง,",
  invalidFtdMax: "การฝากครั้งแรกสูงสุดไม่ถูกต้อง,",
  ftdMinGtFtdMax: "การฝากครั้งแรกขั้นต่ำมากกว่าการฝากครั้งแรกสูงสุด,",
  vipFull: "VIP เต็ม,",
  invalidRewardType: "ประเภทของรางวัลไม่ถูกต้อง,",
  vipExists: "VIP มีอยู่จริง,",
  vipNotExists: "VIP ไม่มีอยู่จริง,",
  onlyOneMaxWithdrawSetting: "อนุญาตให้ตั้งค่าการถอนสูงสุดได้เพียงหนึ่งครั้ง,",
  onlyOneWithholdSetting: "อนุญาตให้ตั้งค่าการหักได้เพียงหนึ่งครั้ง",
  campaignExists: "แคมเปญมีอยู่แล้ว,",
  vipProviderNotExists: "ผู้ให้บริการ VIP ไม่มีอยู่,",
  turnoverTierExists: "ระดับการหมุนเวียนมีอยู่,",
  turnoverTierFull: "ระดับการหมุนเวียนเกินระดับสูงสุด,",
  turnoverTierNotExists: "ระดับการหมุนเวียนไม่มีอยู่,",
  invalidSettingValue: "ค่าการตั้งค่าไม่ถูกต้อง,",
  turnoverTierNotSet: "ระดับการหมุนเวียนไม่ได้ตั้งค่า,",
  rebateProcessed: "การคืนเงินถูกประมวลผล,",
  invalidActionType: "ประเภทการกระทำไม่ถูกต้อง,",
  invalidRescueCycle: "รอบการช่วยเหลือไม่ถูกต้อง,",
  invalidPayoutMethod: "วิธีการจ่ายเงินไม่ถูกต้อง,",
  invalidTargetGroup: "กลุ่มเป้าหมายไม่ถูกต้อง,",
  rescueExists: "การช่วยเหลือมีอยู่,",
  rescueNotExists: "การช่วยเหลือไม่มีอยู่,",
  walletExists: "กระเป๋าเงินมีอยู่,",
  accountExists: "บัญชีมีอยู่,",
  activeFromGtActiveTo: "วันที่เริ่มต้นมากกว่าวันที่สิ้นสุด,",
  accountNotExists: "รหัสผู้ดำเนินการไม่มีอยู่,",
  invalidDeposit: "เงินฝากไม่ถูกต้อง,",
  invalidTurnover: "การหมุนเวียนไม่ถูกต้อง",
  providerCodeNotExists: "รหัสผู้ให้บริการไม่มีอยู่จริง,",
  gameNameExists: "ชื่อเกมมีอยู่,",
  gameNameNotExists: "ชื่อเกมไม่มีอยู่จริง,",
  invalidAccountType: "ประเภทบัญชีไม่ถูกต้อง,",
  invalidLoginIdFormat: "รูปแบบ ID การเข้าสู่ระบบไม่ถูกต้อง,",
  invalidReferralCode: "รหัสการแนะนำไม่ถูกต้อง",
  firstDepositNotMet: "ยอดฝากแรกไม่ตรงตามที่กำหนด,",
  newbieNotMet: "ไม่ตรงตามข้อกำหนดของผู้เล่นใหม่,",
  claimPromoOnlyOnce: "ขอรับโปรโมชั่นได้เพียงครั้งเดียว,",
  promotionRequirementNotMet: "ไม่ตรงตามข้อกำหนดของโปรโมชั่น",
  withdrawalAmountLteWithholdAmount: "จำนวนเงินถอนน้อยกว่าหรือเท่ากับจำนวนเงินที่ถูกระงับ,",
  subAccountInactive: "บัญชีย่อยไม่เคลื่อนไหว,",
  gameNotSupported: "เกมไม่รองรับ,",
  startTimeGteEndTime: "เวลาเริ่มต้นมากกว่าหรือเท่ากับเวลาสิ้นสุด,",
  invalidPromotionType: "ประเภทโปรโมชั่นไม่ถูกต้อง",
  invalidClaimType: "ประเภทการเรียกร้องไม่ถูกต้อง,",
  claimLimitExceeded10: "เกินขีดจำกัดการเรียกร้อง 10,",
  verificationFailed: "การตรวจสอบล้มเหลว,",
  claimLimitReached: "ถึงขีดจำกัดการเรียกร้องแล้ว,",
  invalidPromotion: "โปรโมชั่นไม่ถูกต้อง,",
  socialPlatformExists: "มีแพลตฟอร์มโซเชียล,",
  duplicateReview: "รีวิวซ้ำ,",
  invalidSurveyId: "รหัสสำรวจไม่ถูกต้อง,",
  accountNotBlock: "บัญชีไม่ถูกบล็อก,",
  walletNotExists: "กระเป๋าเงินไม่มีอยู่,",
  socialPlatformNotExists: "แพลตฟอร์มโซเชียลไม่มีอยู่,",
  socialPlatformInactive: "แพลตฟอร์มโซเชียลไม่ทำงาน,",
  accountSocialExists: "บัญชีโซเชียลมีอยู่,",
  invalidStatus: "สถานะไม่ถูกต้อง,",
  samePassword: "รหัสผ่านเหมือนกัน,",
  invalidPassword: "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง,",
  secondaryAccountExists: "บัญชีรองมีอยู่,",
  invalidSecurityCode: "รหัสความปลอดภัยไม่ถูกต้อง,",
  accountSocialNotExists: "บัญชีโซเชียลไม่มีอยู่,",
  providerInactive: "ผู้ให้บริการไม่ทำงาน,",
  gameIdExists: "รหัสเกมมีอยู่,",
  gameIdNotExists: "รหัสเกมไม่มีอยู่,",
  parentProviderInactive: "ผู้ให้บริการหลักไม่ทำงาน,",
  betLimitNotExists: "ขีดจำกัดการเดิมพันไม่มีอยู่,",
  min3Characters: "ขั้นต่ำ 3 ตัวอักษร,",
  invalidBankAccType: "ประเภทบัญชีธนาคารไม่ถูกต้อง,",
  senderBankNotExists: "ธนาคารผู้ส่งไม่มีอยู่,",
  recipientBankNotExists: "ธนาคารผู้รับไม่มีอยู่,",
  affiliateNotExists: "พันธมิตรไม่มีอยู่,",
  redepositedTicket: "ตั๋วที่ฝากใหม่,",
  invalidDepositType: "ประเภทการฝากไม่ถูกต้อง,",
  affiliateInactive: "พันธมิตรไม่ทำงาน,",
  bonusUnavailable: "โบนัสไม่พร้อมใช้งาน,",
  pendingDeposit: "การฝากรอดำเนินการ,",
  noOngoingPromotion: "ไม่มีโปรโมชั่นที่กำลังดำเนินอยู่",
  iframeNotExists: "IFrame ไม่มีอยู่.,",
  gameMaintenance: "กำลังบำรุงรักษาเกม.,",
  labelInactive: "ป้ายกำกับไม่ใช้งาน.,",
  invalidDomainType: "ประเภทโดเมนไม่ถูกต้อง.,",
  invalidModule: "โมดูลไม่ถูกต้อง.,",
  labelFull: "ป้ายกำกับเต็ม.,",
  questionExists: "คำถามมีอยู่.,",
  questionFull: "คำถามเต็ม.,",
  questionNotExists: "คำถามไม่มีอยู่.,",
  reviewNotExists: "รีวิวไม่มีอยู่.,",
  invalidDomainGroup: "กลุ่มโดเมนไม่ถูกต้อง.,",
  invalidDateRange: "ช่วงวันที่ไม่ถูกต้อง.,",
  ipAddressNotExists: "ที่อยู่ IP ไม่มีอยู่.,",
  marqueeNotExists: "ป้ายวิ่งไม่มีอยู่.,",
  invalidAmount: "จำนวนไม่ถูกต้อง.,",
  insufficientBalance: "ยอดเงินไม่เพียงพอ.,",
  minLimitLtParent: "ขั้นต่ำต่ำกว่าแม่.,",
  maxLimitGtParent: "สูงสุดมากกว่าแม่.,",
  startDateGtEndDate: "วันที่เริ่มต้นมากกว่าวันที่สิ้นสุด.,",
  currencyNotExists: "สกุลเงินไม่มีอยู่.,",
  currencyExists: "สกุลเงินมีอยู่.,",
  noAccumulateWin: "ไม่มีการชนะสะสม.,",
  invalidSession: "เซสชันไม่ถูกต้อง.,",
  sessionExpired: "เซสชันหมดอายุ.,",
  promotionExists: "โปรโมชั่นมีอยู่.,",
  invalidCriteria: "เกณฑ์ไม่ถูกต้อง.,",
  promotionNotExists: "โปรโมชั่นไม่มีอยู่.,",
  ticketNotExists: "ตั๋วไม่มีอยู่.,",
  duplicateDebitRecord: "บันทึกการหักซ้ำ.,",
  duplicateCreditRecord: "บันทึกการเครดิตซ้ำ.,",
  debitRecordNotExists: "บันทึกการหักไม่มีอยู่.,",
  minDepositNotMet: "เงินฝากขั้นต่ำไม่ถึง.,",
  duplicateBet: "เดิมพันซ้ำ.",
  invalidProviderCode: "รหัสผู้ให้บริการไม่ถูกต้อง",
  resultExists: "ผลลัพธ์มีอยู่แล้ว",
  unableSPProcess: "ระบบไม่สามารถดำเนินการคำขอของคุณได้",
  authRequired: "ต้องการรหัสการตรวจสอบสิทธิ์",
  domainExists: "โดเมนนี้มีอยู่แล้ว,",
  multiSelectOption: "กรุณาเลือก {fname},",
  invalidDomainFormat: "รูปแบบโดเมนไม่ถูกต้อง",
  noHttpHttps: "'https://' หรือ 'http://' ไม่ได้รับอนุญาต",
  noReservedSubdomain: "ไม่อนุญาตให้ใช้ซับโดเมนที่จองไว้ สำหรับการใช้งานลิงก์ดาวน์โหลดแอป,",
  operatorInactive: "ผู้ดำเนินการไม่ใช้งาน,",
  invalidAccountIdFormat: "รูปแบบรหัสบัญชีไม่ถูกต้อง,",
  contentIdRequired: "ต้องระบุรหัสเมนู,",
  themeCodeRequired: "ต้องระบุรหัสธีม,",
  themeNameRequired: "ต้องระบุชื่อธีม,",
  themeColorRequired: "ต้องระบุสีธีม,",
  languageRequired: "ต้องระบุภาษา,",
  positionRequired: "ต้องระบุตำแหน่ง,",
  themeContentIdRequired: "ต้องระบุรหัสเนื้อหาธีม,",
  emailRequired: "ต้องระบุอีเมล,",
  themeProviderTypeRequired: "ต้องระบุประเภทผู้ให้บริการธีม,",
  phoneRequired: "ต้องระบุโทรศัพท์,",
  targetTypeRequired: "ต้องระบุประเภทเป้าหมาย,",
  packageTypeRequired: "ต้องระบุประเภทแพ็คเกจ,",
  renewTermRequired: "ต้องระบุระยะเวลาในการต่ออายุ,",
  packagePriceRequired: "ต้องระบุราคาของแพ็คเกจ,",
  packageStatusRequired: "ต้องระบุสถานะของแพ็คเกจ,",
  sortKeyRequired: "ต้องระบุคีย์การจัดเรียง,",
  invalidDomainStatus: "สถานะโดเมนไม่ถูกต้อง,",
  invalidCurrency: "สกุลเงินไม่ถูกต้อง,",
  invalidThemeCode: "รหัสธีมไม่ถูกต้อง,",
  invalidLanguage: "ภาษาที่ไม่ถูกต้อง,",
  invalidPosition: "ตำแหน่งไม่ถูกต้อง,",
  invalidThemeContent: "เนื้อหาธีมไม่ถูกต้อง,",
  allParamsSameAsCurrent: "ไม่มีการเปลี่ยนแปลง,",
  invalidThemeColor: "สีธีมไม่ถูกต้อง,",
  invalidCartStatus: "สถานะตะกร้าไม่ถูกต้อง,",
  invalidThemeProviderType: "ประเภทผู้ให้บริการธีมไม่ถูกต้อง,",
  themeProviderTypeCannotBeUse: "ไม่สามารถใช้ประเภทผู้ให้บริการธีมได้,",
  invalidUserStatus: "สถานะผู้ใช้ไม่ถูกต้อง,",
  packageCannotBeRemove: "ไม่สามารถลบแพ็คเกจได้,",
  userStatusIsAlrdSuspend: "ผู้ใช้ถูกระงับแล้ว,",
  userStatusIsAlrdBlocked: "ผู้ใช้ถูกบล็อกแล้ว,",
  userStatusIsAlrdActive: "ผู้ใช้ยังคงใช้งานอยู่,",
  invalidSortType: "ประเภทการจัดเรียงไม่ถูกต้อง,",
  startDateBiggerThanEndDate: "วันที่เริ่มต้นมากกว่าวันที่สิ้นสุด,",
  positionCannotBeUse: "ไม่สามารถใช้ตำแหน่งได้,",
  funcAddContentFailed: "ไม่สามารถเพิ่มเนื้อหาได้,",
  funcDeleteContentFailed: "ไม่สามารถลบเนื้อหาได้,",
  funcUpdateContentFailed: "ไม่สามารถอัปเดตเนื้อหาได้,",
  funcAddThemeFailed: "ไม่สามารถเพิ่มธีมได้,",
  funcDeleteThemeFailed: "ไม่สามารถลบธีมได้,",
  funcUpdateThemeFailed: "ไม่สามารถอัปเดตธีมได้,",
  funcAddThemeColorFailed: "ไม่สามารถเพิ่มสีธีมได้,",
  funcDeleteThemeColorFailed: "ไม่สามารถลบสีธีมได้,",
  funcUpdateThemeColorFailed: "ไม่สามารถอัปเดตสีธีมได้,",
  funcAddLanguageFailed: "ไม่สามารถเพิ่มภาษาได้,",
  funcDeleteLanguageFailed: "ไม่สามารถลบภาษาได้,",
  funcUpdateLanguageFailed: "ไม่สามารถอัปเดตภาษาได้,",
  funcAddThemeContentFailed: "ไม่สามารถเพิ่มเนื้อหาธีมได้,",
  funcDeleteThemeContentFailed: "ไม่สามารถลบเนื้อหาธีมได้,",
  funcUpdateThemeContentFailed: "ไม่สามารถอัปเดตเนื้อหาธีมได้,",
  funcAddContentPositionFailed: "ไม่สามารถเพิ่มตำแหน่งเนื้อหาได้,",
  funcUpdateContentPositionFailed: "ไม่สามารถอัปเดตตำแหน่งเนื้อหาได้,",
  funcDeleteContentPositionFailed: "ไม่สามารถลบตำแหน่งเนื้อหาได้,",
  funcAddThemeProviderTypeFailed: "ไม่สามารถเพิ่มประเภทผู้ให้บริการธีมได้,",
  funcUpdateThemeProviderTypeFailed: "ไม่สามารถอัปเดตประเภทผู้ให้บริการธีมได้,",
  funcDeleteThemeProviderTypeFailed: "ไม่สามารถลบประเภทผู้ให้บริการธีมได้,",
  funcAddPackageFailed: "ไม่สามารถเพิ่มแพ็คเกจได้,",
  funcUpdatePackageFailed: "ไม่สามารถอัปเดตแพ็คเกจได้,",
  funcDeletePackageFailed: "ไม่สามารถลบแพ็คเกจได้,",
  nicknameRequired: "ต้องระบุชื่อเล่น,",
  accountStatusRequired: "ต้องระบุสถานะบัญชี,",
  contentIdMaxLength50: "ความยาวสูงสุดของรหัสเมนูคือ 50",
  positionMaxLength10: "ความยาวสูงสุดของตำแหน่งคือ 10,",
  contentDescMaxLength200: "ความยาวสูงสุดของคำอธิบายเนื้อหาคือ 200,",
  domainStatusRequired: "สถานะโดเมนเป็นสิ่งที่จำเป็น,",
  funcAddDomainFailed: "ไม่สามารถเพิ่มโดเมนได้,",
  funcUpdateDomainFailed: "ไม่สามารถอัปเดตโดเมนได้,",
  uploadFailed: "การอัปโหลดล้มเหลว!",
  sortKeyMaxLength50: "ความยาวสูงสุดของคีย์การจัดเรียงคือ 50,",
  invalidSortTypeFormat: "รูปแบบประเภทการจัดเรียงไม่ถูกต้อง,",
  invalidPackageId: "รหัสแพ็คเกจไม่ถูกต้อง,",
  invalidAccountStatusFormat: "รูปแบบสถานะบัญชีไม่ถูกต้อง,",
  invalidSiteStatusFormat: "รูปแบบสถานะไซต์ไม่ถูกต้อง,",
  invalidPackageStatus: "สถานะแพ็คเกจไม่ถูกต้อง,",
  invalidEmailFormat: "รูปแบบอีเมลไม่ถูกต้อง,",
  invalidPhoneFormat: "รูปแบบโทรศัพท์ไม่ถูกต้อง,",
  languageLengthNotInRange: "ความยาวของภาษาไม่อยู่ในช่วง (2-5),",
  languageDescriptionMaxLength50: "ความยาวสูงสุดของคำอธิบายภาษาไม่เกิน 50,",
  remarkMaxLength500: "ความยาวสูงสุดของหมายเหตุไม่เกิน 500,",
  themeProviderTypeMaxLength50: "ความยาวสูงสุดของประเภทผู้ให้บริการธีมไม่เกิน 50,",
  themeNameMaxLength50: "ความยาวสูงสุดของชื่อธีมไม่เกิน 50,",
  themeColorMaxLength20: "ความยาวสูงสุดของสีธีมไม่เกิน 20",
  noSpace: "ต้องไม่มีช่องว่าง",
  packageDescEnRequired: "ชื่อภาษาอังกฤษเป็นสิ่งจำเป็น,",
  packageDescEnMaxLength20: "ชื่อภาษาอังกฤษมีความยาวสูงสุด 20 ตัวอักษร,",
  allParamsIsNull: "พารามิเตอร์ทั้งหมดเป็นค่า null,",
  contentCannotBeRemove: "ไม่สามารถลบเนื้อหาได้,",
  contentDetailsRequired: "รายละเอียดเนื้อหาเป็นสิ่งจำเป็น,",
  domainCannotBeUse: "ไม่สามารถใช้โดเมนได้,",
  domainGroupMaxLength20: "กลุ่มโดเมนมีความยาวสูงสุด 20 ตัวอักษร,",
  domainGroupRequired: "กลุ่มโดเมนเป็นสิ่งจำเป็น,",
  domainNameCannotUpdate: "ไม่สามารถอัปเดตชื่อโดเมนได้",
  domainNameMaxLength400: "ชื่อโดเมนมีความยาวสูงสุด 400 ตัวอักษร,",
  domainsRequired: "ต้องระบุโดเมน,",
  domainStatusMaxLength20: "สถานะโดเมนมีความยาวสูงสุด 20 ตัวอักษร,",
  domainTypeMaxLength10: "ประเภทโดเมนมีความยาวสูงสุด 10 ตัวอักษร,",
  funcAddThemeContentGroupFailed: "เพิ่มกลุ่มเนื้อหาธีมล้มเหลว,",
  funcDeleteThemeContentGroupFailed: "ลบกลุ่มเนื้อหาธีมล้มเหลว,",
  funcOpsiteUpdateFailed: "การอัปเดต Opsite ล้มเหลว,",
  funcResetAccountPasswordFailed: "รีเซ็ตรหัสผ่านบัญชีล้มเหลว,",
  funcSiteLanguageUpsertFailed: "การอัปเดตภาษาของไซต์ล้มเหลว,",
  funcSiteThemeContentUpsertFailed: "การอัปเดตเนื้อหาธีมของไซต์ล้มเหลว,",
  funcSiteThemeUpsertFailed: "การอัปเดตธีมของไซต์ล้มเหลว,",
  funcSiteUpdateFailed: "การอัปเดตไซต์ล้มเหลว,",
  funcUpdateAccountFailed: "การอัปเดตบัญชีล้มเหลว,",
  funcUpdateAccountStatusActiveFailed: "การอัปเดตสถานะบัญชีเป็นใช้งานล้มเหลว,",
  funcUpdateAccountStatusCompanyBlockFailed: "การอัปเดตสถานะบัญชีเป็นบล็อกบริษัทล้มเหลว,",
  funcUpdateAccountStatusSuspendFailed: "การอัปเดตสถานะบัญชีเป็นระงับล้มเหลว,",
  funcUpdateThemeContentGroupFailed: "การอัปเดตกลุ่มเนื้อหาธีมล้มเหลว",
  invalidBoDomain: "โดเมน BO ไม่ถูกต้อง,",
  invalidOperatorIdFormat: "รูปแบบรหัสผู้ใช้ไม่ถูกต้อง,",
  invalidOpsite: "ไซต์ไม่ถูกต้อง,",
  invalidOpsiteOperator: "ผู้ใช้ไซต์ไม่ถูกต้อง,",
  invalidOpsiteVersion: "เวอร์ชันไซต์ไม่ถูกต้อง,",
  invalidParentContentInGroup: "เนื้อหาหมายเลขหลักในกลุ่มไม่ถูกต้อง,",
  invalidSite: "ไซต์ไม่ถูกต้อง,",
  invalidSiteStatus: "สถานะไซต์ไม่ถูกต้อง,",
  invalidThemeContentGroup: "กลุ่มเนื้อหาธีมไม่ถูกต้อง",
  languageCannotBeUse: "ไม่สามารถใช้ภาษาได้,",
  languagesRequired: "ต้องการภาษาทั้งหมด,",
  logo1Required: "ต้องการโลโก้,",
  notSupportMultiDefault: "ไม่รองรับหลายค่าเริ่มต้น,",
  operatorIdMaxLength50: "รหัสผู้ดำเนินการมีความยาวสูงสุด 50 ตัวอักษร,",
  opsiteNotMatch: "ไซต์ไม่ตรงกัน,",
  packageTypeMaxLength15: "ประเภทแพ็คเกจมีความยาวสูงสุด 15 ตัวอักษร",
  parentContentIdCannotSameWithContentId: "รหัสเนื้อหาหลักไม่สามารถเป็นรหัสเนื้อหาเดียวกันได้,",
  phoneNumberRequired: "หมายเลขโทรศัพท์เป็นสิ่งจำเป็น,",
  siteIdRequired: "รหัสไซต์เป็นสิ่งจำเป็น,",
  siteNameMaxLength50: "ชื่อไซต์มีความยาวสูงสุด 50 ตัวอักษร,",
  siteNameRequired: "ชื่อไซต์เป็นสิ่งจำเป็น,",
  technicalError: "ข้อผิดพลาดทางเทคนิค,",
  themeCannotBeRemove: "ไม่สามารถลบธีมได้,",
  themeCodeCannotBeUse: "ไม่สามารถใช้รหัสธีมได้,",
  themeCodeMaxLength20: "รหัสธีมมีความยาวสูงสุด 20 ตัวอักษร,",
  themeColorCannotBeRemove: "ไม่สามารถลบสีธีมได้,",
  themeColorCannotBeUse: "ไม่สามารถใช้สีธีมได้,",
  themeContentCannotBeUse: "ไม่สามารถใช้เนื้อหาธีมได้,",
  themeContentGroupCannotBeUse: "ไม่สามารถใช้กลุ่มเนื้อหาธีมได้,",
  themeContentGroupDescriptionMaxLength50: "คำอธิบายกลุ่มเนื้อหาธีมมีความยาวสูงสุด 50 ตัวอักษร,",
  themeContentGroupMaxLength20: "กลุ่มเนื้อหาธีมมีความยาวสูงสุด 20 ตัวอักษร,",
  themeContentGroupRequired: "กลุ่มเนื้อหาธีมเป็นสิ่งจำเป็น,",
  themeNameCannotBeUse: "ไม่สามารถใช้ชื่อธีมได้,",
  userHaventVerifyThisBefore: "ผู้ใช้ยังไม่ได้ยืนยันสิ่งนี้มาก่อน,",
  isDefaultTrueRequired: "ภาษาต้องมีค่าเริ่มต้น 1 ค่า,",
  accountIdMaxLength50: "รหัสผู้ใช้มีความยาวสูงสุด 50 ตัวอักษร",
  headBodyScriptEitherOne: "กรุณาใส่ Head Script หรือ Body Script",
  alphaOrNum: "ต้องเป็นตัวอักษรหรือตัวเลขเท่านั้น,",
  phoneValid: "กรุณาใส่หมายเลขโทรศัพท์ที่ถูกต้อง,",
  permittedAmountRequired: "จำนวนที่อนุญาตจำเป็นต้องมี,",
  ignoreRiskRequired: "การละเลยความเสี่ยงจำเป็นต้องมี,",
  paymentDescRequired: "คำอธิบายการชำระเงินจำเป็นต้องมี,",
  gameTypeRequired: "ประเภทเกมจำเป็นต้องมี,",
  statusRequired: "สถานะจำเป็นต้องมี,",
  payoutIdRequired: "รหัสการจ่ายเงินจำเป็นต้องมี,",
  commNotExists: "ไม่มีค่าคอมมิชชั่น,",
  parentCommNotExists: "ไม่มีค่าคอมมิชชั่นหลัก,",
  carryOverNotExists: "ไม่มีการโอน,",
  hotGameExists: "เกมยอดนิยมมีอยู่แล้ว,",
  commSportsExceededParent: "ค่าคอมมิชชั่นสำหรับกีฬาเกินค่าคอมมิชชั่นหลัก,",
  commSlotsExceededParent: "ค่าคอมมิชชั่นสำหรับสล็อตเกินค่าคอมมิชชั่นหลัก,",
  commLivecasinoExceededParent: "ค่าคอมมิชชั่นสำหรับคาสิโนสดเกินค่าคอมมิชชั่นหลัก,",
  commCockfightExceededParent: "ค่าคอมมิชชั่นสำหรับการต่อสู้ไก่เกินค่าคอมมิชชั่นหลัก,",
  commOthersExceededParent: "ค่าคอมมิชชั่นสำหรับอื่นๆ เกินค่าคอมมิชชั่นหลัก,",
  hotGameNotExists: "เกมยอดนิยมไม่มีอยู่,",
  noSecurityDeposit: "ไม่มีเงินทุนรักษาความปลอดภัย,",
  exchangeRateNotExists: "ไม่มีอัตราแลกเปลี่ยน,",
  insufficientSecurityDeposit: "เงินทุนรักษาความปลอดภัยไม่เพียงพอ,",
  duplicateDomain: "โดเมนซ้ำ,",
  contactEmailNotExists: "อีเมลติดต่อไม่มีอยู่,",
  featuredGameNotExists: "เกมฟีเจอร์ไม่มีอยู่,",
  newGameNotExists: "เกมใหม่ไม่มีอยู่,",
  popularGameNotExists: "เกมยอดนิยมไม่มีอยู่,",
  featuredGameExists: "เกมฟีเจอร์มีอยู่แล้ว,",
  newGameExists: "เกมใหม่มีอยู่แล้ว,",
  popularGameExists: "เกมยอดนิยมมีอยู่แล้ว",
  rebateNotExists: "ไม่มีการคืนเงิน",
  riskyMember: "สมาชิกที่มีความเสี่ยง",
  ipRestricted: "IP ถูกจำกัด",
  notSupportedBank: "ธนาคารที่ไม่รองรับ,",
  requestTooFrequent: "คำขอถี่เกินไป",
  paymentOptionNotExists: "ไม่มีตัวเลือกการชำระเงิน",
  earningIdRequired: "ต้องระบุรหัสรายได้",
  ptOnRequired: "ต้องเปิด PT",
  ptRequired: "ต้องระบุ PT",
  businessIdRequired: "ต้องระบุรหัสธุรกิจ",
  subAccountIdRequired: "ต้องระบุรหัสบัญชีย่อย",
  sourceAccountIdRequired: "ต้องระบุรหัสบัญชีต้นทาง",
  targetAccountIdRequired: "ต้องระบุรหัสบัญชีปลายทาง",
  ticketTaken: "ตั๋วนี้ถูกใช้ไปแล้ว",
  ticketNotTaken: "ยังไม่ได้รับตั๋ว",
  invalidPt: "PT ไม่ถูกต้อง",
  topupIdRequired: "ต้องระบุรหัสเติมเงิน",
  promotionMemberLogNotExists: "ไม่มีบันทึกสมาชิกโปรโมชั่น",
  paymentOptionInactive: "ตัวเลือกการชำระเงินไม่ได้ใช้งาน",
  invalidCartStatusFormat: "รูปแบบสถานะรถเข็นไม่ถูกต้อง,",
  requestIncompleted: 'คำขอไม่สมบูรณ์',
  unknownError: 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ',
  cartIdRequired: "ต้องระบุรหัสตะกร้าสินค้า",
  stepNameRequired: "ต้องระบุชื่อลำดับขั้น",
  invalidCart: "ตะกร้าสินค้าไม่ถูกต้อง",
  invalidStepName: "ชื่อลำดับขั้นไม่ถูกต้อง",
  cartHaventSetupComplete: "การตั้งค่าตะกร้าสินค้ายังไม่สมบูรณ์",
  funcCartCreateFailed: "ไม่สามารถสร้างตะกร้าสินค้าได้",
  funcCartUpdateFailed: "ไม่สามารถอัปเดตตะกร้าสินค้าได้",
  funcSiteCreateFailed: "ไม่สามารถสร้างเว็บไซต์ได้",
  funcCartPurchasedUpdateFailed: "ไม่สามารถอัปเดตการซื้อของตะกร้าสินค้าได้",
  invalidPasswordFormat: "รูปแบบรหัสผ่านไม่ถูกต้อง",
  currencyCodeRequired: "ต้องระบุสกุลเงิน",
  funcCartLanguageUpsertFailed: "ไม่สามารถอัปเดตภาษาของตะกร้าสินค้าได้",
  invalidUserIdFormat: "รูปแบบรหัสผู้ใช้ไม่ถูกต้อง",
  operatorPasswordRequired: "ต้องระบุรหัสผ่านของผู้ดำเนินการ",
  funcCartOperatorInfoUpsertFailed: "ไม่สามารถอัปเดตข้อมูลผู้ดำเนินการของตะกร้าสินค้าได้",
  invalidOperatorPasswordFormat: "รูปแบบรหัสผ่านของผู้ดำเนินการไม่ถูกต้อง",
  operatorIdCannotBeUse: "ไม่สามารถใช้รหัสผู้ดำเนินการได้",
  siteNameLengthNotInRange: "ความยาวชื่อเว็บไซต์ไม่อยู่ในช่วงที่กำหนด",
  userIdCannotBeUse: "ไม่สามารถใช้รหัสผู้ใช้ได้",
  siteIdAlrdExist: "รหัสเว็บไซต์มีอยู่แล้ว",
  operatorIdAlrdExist: "รหัสผู้ดำเนินการมีอยู่แล้ว",
  externalIdAlrdExist: "รหัสภายนอกมีอยู่แล้ว",
  opsiteContentAlrdExist: "เนื้อหาธีมของเว็บไซต์มีอยู่แล้ว",
  opsiteLanguageAlrdExist: "ภาษาของเนื้อหาเว็บไซต์มีอยู่แล้ว",
  boAccountAlrdExist: "บัญชี BO มีอยู่แล้ว",
  boAccountProfileAlrdExist: "โปรไฟล์บัญชี BO มีอยู่แล้ว",
  boAccountLoginAlrdExist: "บัญชีเข้าสู่ระบบ BO มีอยู่แล้ว",
  funcCartThemeCodeUpsertFailed: "ไม่สามารถอัปเดตธีมของตะกร้าสินค้าได้",
  funcCartThemeColorUpsertFailed: "ไม่สามารถอัปเดตสีของตะกร้าสินค้าได้",
  funcOpsiteCreateFailed: "ไม่สามารถสร้างเนื้อหาเว็บไซต์ได้",
  alphabetValid: "ต้องมีตัวอักษรตัวใหญ่และตัวเล็กอย่างน้อยหนึ่งตัว",
  numberValid: "ต้องมีตัวเลขอย่างน้อยหนึ่งตัว",
  symbolValid: "ต้องมีสัญลักษณ์อย่างน้อยหนึ่งตัว",
  credentialNotSet: "ไม่ได้ตั้งค่าข้อมูลรับรอง",
  validBankAccFormat: "รูปแบบหมายเลขบัญชีธนาคารไม่ถูกต้อง",
  moreThan: "{fname} ต้องน้อยกว่าหรือเท่ากับ {fname2}",
  lessThan: "{fname} ต้องมากกว่าหรือเท่ากับ {fname2}.",
  bankAccountNotAvailable: "ไม่มีบัญชีธนาคาร.",
  insufficientCredit: "เครดิตไม่เพียงพอ",
  enableRequired: "ต้องเปิดใช้งาน",
  funcAddGameFailed: "เพิ่มเกมล้มเหลว",
  funcAddGameRewardByBatchFailed: "เพิ่มรางวัลเกมแบบกลุ่มล้มเหลว",
  funcAddGameRewardFailed: "เพิ่มรางวัลเกมล้มเหลว",
  funcAddGameTemplateFailed: "เพิ่มเทมเพลตเกมล้มเหลว",
  funcAddLayoutTemplateFailed: "เพิ่มเทมเพลตเลย์เอาต์ล้มเหลว",
  funcAddOperatorGameFailed: "เพิ่มเกมผู้ให้บริการล้มเหลว",
  funcAddOperatorMemberWalletFailed: "เพิ่มกระเป๋าเงินสมาชิกผู้ให้บริการล้มเหลว",
  funcDeleteGameFailed: "ลบเกมล้มเหลว",
  funcDeleteGameRewardFailed: "ลบรางวัลเกมล้มเหลว",
  funcDeleteGameTemplateFailed: "ลบเทมเพลตเกมล้มเหลว",
  funcDeleteLayoutTemplateFailed: "ลบเทมเพลตเลย์เอาต์ล้มเหลว",
  funcDeleteOperatorGameFailed: "ลบเกมผู้ให้บริการล้มเหลว",
  funcUpdateGameFailed: "อัปเดตเกมล้มเหลว",
  funcUpdateGameRewardFailed: "อัปเดตรางวัลเกมล้มเหลว",
  funcUpdateGameTemplateFailed: "อัปเดตเทมเพลตเกมล้มเหลว",
  funcUpdateLayoutTemplateFailed: "อัปเดตเทมเพลตเลย์เอาต์ล้มเหลว",
  funcUpdateOperatorGameFailed: "อัปเดตเกมผู้ให้บริการล้มเหลว",
  gameCannotBeRemove: "ไม่สามารถลบเกมได้",
  gameNameCannotBeUse: "ไม่สามารถใช้ชื่อเกมนี้ได้",
  gameNameMaxLength150: "ชื่อเกมต้องมีไม่เกิน 150 ตัวอักษร",
  gameRewardCannotBeUse: "ไม่สามารถใช้รางวัลเกมนี้ได้",
  gameRewardLimitExceeded: "เกินขีดจำกัดของรางวัลเกม",
  gameTemplateExist: "เทมเพลตเกมมีอยู่แล้ว",
  gameTypeMaxLength20: "ประเภทเกมต้องมีไม่เกิน 20 ตัวอักษร",
  invalidGame: "เกมไม่ถูกต้อง",
  invalidGameReward: "รางวัลเกมไม่ถูกต้อง",
  invalidGameTemplate: "เทมเพลตเกมไม่ถูกต้อง",
  invalidMemberWallet: "กระเป๋าเงินสมาชิกไม่ถูกต้อง",
  invalidOperatorGame: "เกมผู้ให้บริการไม่ถูกต้อง",
  invalidRewardProbability: "ความน่าจะเป็นของรางวัลไม่ถูกต้อง",
  invalidTemplate: "เทมเพลตไม่ถูกต้อง",
  maxGameRewardRequired: "ต้องระบุรางวัลเกมสูงสุด",
  maxMiniGameRewardRequired: "ต้องระบุรางวัลสูงสุดของมินิเกม",
  memberWalletAlrdExist: "กระเป๋าเงินสมาชิกมีอยู่แล้ว",
  operatorGameCannotBeUse: "ไม่สามารถใช้เกมผู้ให้บริการได้",
  operatorGameIdRequired: "ต้องระบุรหัสเกมผู้ให้บริการ",
  rewardCodeMaxLength20: "รหัสรางวัลต้องมีไม่เกิน 20 ตัวอักษร",
  rewardCodeRequired: "ต้องระบุรหัสรางวัล",
  rewardCurrencyMaxLength5: "สกุลเงินรางวัลต้องมีไม่เกิน 5 ตัวอักษร",
  rewardCurrencyRequired: "ต้องระบุสกุลเงินรางวัล",
  rewardDescriptionMaxLength100: "คำอธิบายรางวัลต้องมีไม่เกิน 100 ตัวอักษร",
  rewardNameMaxLength50: "ชื่อต้องมีไม่เกิน 50 ตัวอักษร",
  rewardProbabilityRequired: "ต้องระบุความน่าจะเป็นของรางวัล",
  rewardRequired: "ต้องระบุรางวัล",
  selectedTemplateMaxLength30: "เทมเพลตที่เลือกต้องมีไม่เกิน 30 ตัวอักษร",
  selectedTemplateRequired: "ต้องเลือกเทมเพลต",
  success: "สำเร็จ",
  templateCannotBeRemove: "ไม่สามารถลบเทมเพลตได้",
  templateCodeCannotBeUse: "ไม่สามารถใช้รหัสเทมเพลตได้",
  templateCodeMaxLength30: "รหัสเทมเพลตต้องมีไม่เกิน 30 ตัวอักษร",
  templateCodeRequired: "ต้องระบุรหัสเทมเพลต",
  templateNameMaxLength50: "ชื่อเทมเพลตต้องมีไม่เกิน 50 ตัวอักษร",
  tokenRequestRequired: "ต้องระบุคำขอโทเค็น",
  tokenRequired: "ต้องระบุโทเค็น",
  mustMoreThan: "{fname} ต้องมากกว่า {fvalue}",
  mustMoreThanOrEqual: "{fname} ต้องมากกว่าหรือเท่ากับ {fvalue}",
  tokenInvalid: "ข้อมูล Token ไม่ถูกต้องที่ {key}",
  cashInvalid: "ข้อมูลเงินสดไม่ถูกต้องที่ {key}",
  atLeastOneRequired: "ต้องกรอกอย่างน้อยหนึ่งรายการ",
  cash1To7Required: "จำเป็นต้องมี Cash 1 ถึง 7",
  cash1To6Required: "จำเป็นต้องมี Cash 1 ถึง 6",
  cash1To5Required: "จำเป็นต้องมี Cash 1 ถึง 5",
  cash1To4Required: "จำเป็นต้องมี Cash 1 ถึง 4",
  cash1To3Required: "จำเป็นต้องมี Cash 1 ถึง 3",
  cash1To2Required: "จำเป็นต้องมี Cash 1 ถึง 2",
  cash1Required: "จำเป็นต้องมี Cash 1",
  token1To7Required: "จำเป็นต้องมี Token 1 ถึง 7",
  token1To6Required: "จำเป็นต้องมี Token 1 ถึง 6",
  token1To5Required: "จำเป็นต้องมี Token 1 ถึง 5",
  token1To4Required: "จำเป็นต้องมี Token 1 ถึง 4",
  token1To3Required: "จำเป็นต้องมี Token 1 ถึง 3",
  token1To2Required: "จำเป็นต้องมี Token 1 ถึง 2",
  token1Required: "จำเป็นต้องมี Token 1",
  cycleRequired: "ต้องระบุรอบ",
  targetAmountRequired: "ต้องระบุจำนวนเป้าหมาย",
  gamifyIdRequired: "ต้องระบุรหัสรางวัล",
  gamifyMemberProcessed: "ดำเนินการรางวัลสมาชิกแล้ว",
  gamifyNotExists: "ไม่มีรางวัลนี้",
  gamifyInactive: "รางวัลไม่ได้ใช้งาน",
  invalidCycle: "รอบไม่ถูกต้อง",
  memberIdMaxLength50: "รหัสสมาชิกต้องไม่เกิน 50 ตัวอักษร",
  funcAddGameWalletFreeCreditFailed: "ไม่สามารถเพิ่มเครดิตฟรีในกระเป๋าเกมได้",
  funcUpdateOperatorMemberWalletBalanceFailed: "ไม่สามารถอัปเดตยอดเงินกระเป๋าสมาชิกของผู้ให้บริการได้",
  funcUpdateOperatorMemberWalletBalanceByFrozenFailed: "ไม่สามารถอัปเดตยอดเงินกระเป๋าสมาชิกของผู้ให้บริการโดยใช้จำนวนเงินที่ถูกแช่แข็งได้",
  mustHaveBothAlphaNumOnly: "ใช้เฉพาะตัวอักษรและตัวเลข โดยต้องมีอย่างน้อยอย่างละหนึ่ง",
  setupGameRewardBeforeEnable: "โปรดตั้งค่ารางวัลเกมก่อนเปิดใช้งาน",
  rewardProbabilityMustNotAllZero: "ความน่าจะเป็นของรางวัลต้องไม่เป็นศูนย์ทั้งหมด",
  totalRewardProbabilityCannotOver100: "ความน่าจะเป็นของรางวัลรวมต้องไม่เกิน 100",
  credential1To2Required: "จำเป็นต้องกรอกข้อมูลรับรอง 1 ถึง 2",
  credential1To4Required: "จำเป็นต้องกรอกข้อมูลรับรอง 1 ถึง 4",
  newRemarkRequired: "จำเป็นต้องกรอกหมายเหตุ",
  notSupportedWithdrawalPG: "เกตเวย์การชำระเงินสำหรับการถอนเงินไม่รองรับ",
  prizeInvalid: "ข้อมูลรางวัลไม่ถูกต้องที่ {key}",
  exceedMaxCampaignCount: "เกินจำนวนแคมเปญสูงสุดในกระดานผู้นำ",
  leaderboardCampaignEnded: "แคมเปญกระดานผู้นำสิ้นสุดแล้ว",
  leaderboardCampaignStarted: "เริ่มแคมเปญกระดานผู้นำแล้ว",
  leaderboardCampaignSettled: "แคมเปญกระดานผู้นำเสร็จสิ้นแล้ว",
  pleaseSelectUpToNoPhone: "โปรดเลือกหมายเลขโทรศัพท์ไม่เกิน {fname} หมายเลข",
  phoneNotAvailable: "ไม่มีโทรศัพท์ให้ใช้งาน.",
  batchExpired: "ชุดหมดอายุ.",
  remarkNotSame: "หมายเหตุไม่ตรงกัน",
  partnerIdRequired: "ต้องระบุรหัสพาร์ทเนอร์",
  partnerNotExists: "ไม่มีพาร์ทเนอร์นี้",
  urgencyRequired: "ต้องระบุความเร่งด่วน",
  groupSizeRequired: "ต้องระบุขนาดกลุ่ม",
  inactiveDaysRequired: "ต้องระบุวันที่ไม่ใช้งาน",
  idRequired: "ต้องระบุรหัส",
  expiryRequired: "ต้องระบุวันหมดอายุ",
  batchIdRequired: "ต้องระบุรหัสแบทช์",
  requestDateRequired: "ต้องระบุวันที่ร้องขอ",
  requestByRequired: "ต้องระบุผู้ร้องขอ",
  cpiIdRequired: "ต้องระบุรหัส CPI",
  assigneeRequired: "ต้องระบุผู้รับมอบหมาย",
  phoneNotAvailable: "ไม่มีโทรศัพท์",
  liveChatNotExists: "ไม่มีแชทสด",
  resultNotExists: "ไม่มีผลลัพธ์",
  lastLaunchFundTransfer: "การโอนเงินเปิดตัวครั้งล่าสุด",
  alreadyRegistered: "ลงทะเบียนแล้ว",
  invalidId: "รหัสไม่ถูกต้อง",
  batchExpired: "แบทช์หมดอายุ",
  teleCalling: "การโทรศัพท์",
  invalidUrgency: "ความเร่งด่วนไม่ถูกต้อง",
  appTypeRequired: "ต้องระบุประเภทแอปพลิเคชัน",
  invalidAppType: "ประเภทแอปพลิเคชันไม่ถูกต้อง",
  appLinkRequired: "ต้องระบุลิงก์แอปพลิเคชัน",
  invalidDomain: "โดเมนไม่ถูกต้อง",
  existEndDateGtEndDate: "วันสิ้นสุดที่มีอยู่ช้ากว่าวันสิ้นสุดใหม่",
  newRemark2Required: "ต้องระบุหมายเหตุใหม่ 2",
  remark2NotSame: "หมายเหตุ 2 ไม่ตรงกัน",
  remark2Required: "ต้องระบุหมายเหตุ 2",
  nameRequired: "ต้องระบุชื่อ",
  aiAssistantNotExists: "ไม่มีผู้ช่วย AI",
  aiAssistantInactive: "ผู้ช่วย AI ไม่ทำงาน",
  phoneStartWithVND: "หมายเลขโทรศัพท์ต้องขึ้นต้นด้วย 84",
  otherActiveLiveChat: "มี LiveChat อื่นที่กำลังใช้งานอยู่",
  whiteLabelRequired: "ต้องการ White Label",
  invalidWhiteLabel: "White Label ไม่ถูกต้อง",
  baseRateDepositRequired: "ต้องการอัตราฐานของการฝาก",
  revisionRequired: "ต้องการการแก้ไข",
  typeDescRequired: "ต้องการคำอธิบายประเภท",
  riskWeightRequired: "ต้องการน้ำหนักความเสี่ยง",
  linkageTypeRequired: "ต้องการประเภทการเชื่อมโยง",
  valueRequired: "ต้องการค่า",
  baseRateWithdrawalRequired: "ต้องการอัตราฐานของการถอน",
  sourceIdRequired: "ต้องการรหัสแหล่งที่มา",
  targetIdRequired: "ต้องการรหัสปลายทาง",
  linkageTypeNotExists: "ไม่มีประเภทการเชื่อมโยงนี้",
  phoneStartWithMYR: "หมายเลขโทรศัพท์ต้องขึ้นต้นด้วย 60",
  minWithdrawalAmount100: "จำนวนถอนขั้นต่ำคือ 100",
  invalidReward: "รางวัลไม่ถูกต้อง",
  noRow: "ไม่มีแถวข้อมูล",
  credentialRequired: "จำเป็นต้องมีข้อมูลรับรอง",
  settlementIdRequired: "จำเป็นต้องมี Settlement ID",
  settlementDateRequired: "จำเป็นต้องมีวันที่ Settlement",
  newCryptoAddressRequired: "จำเป็นต้องมีที่อยู่คริปโตใหม่",
  cryptoAddressRequired: "จำเป็นต้องมีที่อยู่คริปโต",
  settlementTypeRequired: "จำเป็นต้องมีประเภท Settlement",
  chatProviderRequired: "จำเป็นต้องมีผู้ให้บริการแชท",
  countRequired: "จำเป็นต้องมีจำนวน",
  voucherCodeRequired: "จำเป็นต้องมีโค้ดวอเชอร์",
  eventTypeRequired: "จำเป็นต้องมีประเภทเหตุการณ์",
  viewTypeRequired: "จำเป็นต้องมีประเภทมุมมอง",
  actionTypeRequired: "จำเป็นต้องมีประเภทการดำเนินการ",
  thresholdRequired: "จำเป็นต้องมีค่า Threshold",
  missionIdRequired: "จำเป็นต้องมี Mission ID",
  ruleIdRequired: "จำเป็นต้องมี Rule ID",
  aggregatorRequired: "จำเป็นต้องมี Aggregator",
  rebateIdRequired: "จำเป็นต้องมี Rebate ID",
  liveChatExists: "Livechat นี้มีอยู่แล้ว",
  triggerNotExists: "ไม่มี Trigger นี้",
  missionRuleNotExists: "ไม่มี Mission Rule นี้",
  invalidVoucherCode: "โค้ดวอเชอร์ไม่ถูกต้อง",
  invalidRebateType: "ประเภท Rebate ไม่ถูกต้อง",
  invalidSettlementType: "ประเภท Settlement ไม่ถูกต้อง",
  missionNotExists: "ไม่มี Mission นี้",
  settlementTypeNotExists: "ไม่มีประเภท Settlement นี้",
  parentTriggerInactive: "Trigger หลักไม่ใช้งาน",
  parentMissionInactive: "Mission หลักไม่ใช้งาน",
  missionRuleNotSet: "ยังไม่ได้ตั้งค่า Mission Rule",
  invalidCreditType: "ประเภทเครดิตไม่ถูกต้อง",
  cryptoDisabled: "คริปโตถูกปิดใช้งาน",
  depositExists: "มี Deposit นี้อยู่แล้ว",
  parentSettlementTypeNotExists: "ไม่มีประเภท Settlement หลัก",
  accessControlNotExists: "ไม่มี Access Control นี้",
  cryptoAccountFull: "บัญชีคริปโตเต็ม",
  cryptoAccountExists: "บัญชีคริปโตมีอยู่แล้ว",
  cryptoAccountNotExists: "ไม่มีบัญชีคริปโต",
  settlementNotAvailable: "Settlement ไม่พร้อมใช้งาน",
  settlementProcessed: "Settlement ดำเนินการแล้ว",
  cryptoAccountInactive: "บัญชีคริปโตไม่ใช้งาน",
  leadIdRequired: "จำเป็นต้องมี Lead ID",
  failedToCreateFreeRound: "สร้าง Free Round ไม่สำเร็จ",
  failedToGetFreeRound: "ไม่สามารถดึงข้อมูล Free Round ได้",
  failedToGetFreeRoundGameList: "ไม่สามารถดึงรายการเกม Free Round ได้",
  tierFull: "ระดับเต็ม",
  tierNotExists: "ไม่พบระดับ",
  ticketTypeRequired: "กรุณาระบุประเภทตั๋ว",
  invalidTicketType: "ประเภทตั๋วไม่ถูกต้อง",
  positionRequired: "กรุณาระบุตำแหน่ง",
  invalidPosition: "ตำแหน่งไม่ถูกต้อง",
  invalidBonusRate: "อัตราโบนัสไม่ถูกต้อง",
  minRequired: "กรุณาระบุค่าต่ำสุด",
  maxRequired: "กรุณาระบุค่าสูงสุด",
  minGtMax: "ค่าต่ำสุดมากกว่าค่าสูงสุด",
  sessionExists: "เซสชันมีอยู่แล้ว",
  sessionOverlaps: "เซสชันทับซ้อนกัน",
  sessionIdRequired: "กรุณาระบุ Session ID",
  sessionNotExists: "ไม่พบเซสชัน",
  nameExists: "ชื่อนี้มีอยู่แล้ว",
  sessionElapsed: "เซสชันสิ้นสุดแล้ว",
  validUrl: "กรุณากรอก URL ที่ถูกต้อง",
  minBalanceNotMet: "ยอดคงเหลือขั้นต่ำไม่ถึงเกณฑ์",
  validSlugFormat: "รูปแบบสลักไม่ถูกต้อง",

  failedToCancelFreeRound: "ไม่สามารถยกเลิกรอบฟรีได้",
  failedToGetFreeRoundLineBet: "ไม่สามารถรับเดิมพันไลน์ของรอบฟรีได้",
};